// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"755ba742","605":"d12b16ed","809":"62452d41","981":"b845744e"}[chunkId] + ".chunk.js";
};